module.exports = __webpack_public_path__ + "img/e-book.6b295d9a.png";